import enMessages from "../Locales/ar_SA.json";

const arLang = {
  messages: {
    ...enMessages,
  },
  locale: "ar-SA",
};
export default arLang;
